export const ITEMS_PER_PAGE = 10;
export const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50];
export const ITEMS_PER_PAGE_STORAGE_KEY = 'itemsPerPage';
export const DEFAULT_LANG = 'ru';
export const MODAL_ID = 'modal';
export const MAX_RATE_COUNT = 5;
export const DEFAULT_ADDRESS_RADIUS = 50;
